import { AccommodationDetailsQuery } from '../../generated/graphql';
import { useEffect, useRef } from 'react';
import { accommodationTypeMessages } from '../../constants/getAccommodationType';
import { LiteralElement } from 'intl-messageformat-parser';
import { IS_QUALITYLODGINGS } from '../../constants/analyticsEvents';
import { emitQlHotelView } from '../../utils/analytics/qualitylodgingsEvents';

const useAnalyticsAccoView = (acco?: AccommodationDetailsQuery['accommodation']) => {
    const prev = useRef<AccommodationDetailsQuery['accommodation'] | null>(null);

    useEffect(() => {
        if (IS_QUALITYLODGINGS) {
            if (acco && acco.id !== prev.current?.id) {
                prev.current = acco;
                emitQlHotelView({ accommodationName: acco.name });
            }
            return;
        }

        window.dataLayer = window.dataLayer ?? [];

        if (acco && acco.id !== prev.current?.id) {
            prev.current = acco;
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'view_item',
                ecommerce: {
                    items: [
                        {
                            item_category: (accommodationTypeMessages[acco.type].defaultMessage as LiteralElement[])[0]
                                .value,
                            item_id: acco.slug,
                            item_name: acco.name,
                            quantity: 1,
                        },
                    ],
                },
            });
        }
    }, [acco, prev]);
};

export default useAnalyticsAccoView;
